import "bootstrap/dist/css/bootstrap.css";
import {
    createApp
} from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import mitt from 'mitt';
const emitter = mitt();

let app = createApp(App);
app.config.globalProperties.emitter = emitter;
app.use(store)
    .use(router)
    .use(VueAxios, axios)
    .mount("#app");

import "bootstrap/dist/js/bootstrap.js";